//#region Module
import React from 'react';
import PropTypes from 'prop-types';
// material
import { styled } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';
import { Box } from '@mui/material';
//#endregion

//#region CSS
const DRAWER_WIDTH = 380;
const RootStyle = styled('div')(({ theme }) => ({
    [theme.breakpoints.up('lg')]: {
        flexShrink: 0,
    },
}));
const useStyles = makeStyles((theme) => ({
    drawerPaper: {
        width: DRAWER_WIDTH,
        backgroundColor: '#fff',
        left: "142px"
    },
    drawerOpen: {
        width: DRAWER_WIDTH,
    },
    drawerClosed: {
    },
    settingsBox: {
        width: '100%',
    },
    reportSettings: {
        width: '100%',
        height: '100%',
        backgroundColor: '#FFE9E2',
        padding: '1rem',
        borderRadius: '8px',
        [theme.breakpoints.between("lg", "xl")]: {
            padding: '0.5rem',
        },
        [theme.breakpoints.down("lg")]: {
            padding: '0.5rem',
        },
        [theme.breakpoints.down("sm")]: {
            padding: '0.5rem 0.5rem 0.5rem',
        },
        minHeight: '500px',
    },
}));
//#endregion

export default function ReportDashboardSettingSidebar({ isOpenSidebar, children }) {
    const classes = useStyles();
    return (
        <RootStyle className={classes.reportSettings + ` re-dashboard-edit-sidebar`} >
            <Box variant="temporary" anchor="left" className={classes.settingsBox} classes={{ paper: classes.drawerPaper }}>
                <div className='report-settings-drawer'>
                    {children}
                </div>
            </Box>
        </RootStyle>
    );
}


ReportDashboardSettingSidebar.propTypes = {
    isOpenSidebar: PropTypes.bool,
    onCloseSidebar: PropTypes.func
};